import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// Define a type for the slice state

// Define the initial state using that type

const initialState = {
  profilePic: "",
  signedprofilepic: "",
  is_FilePathset: true,
};

const profilePicSlice = createSlice({
  name: "profilePic",

  initialState,
  reducers: {
    setUserProfilePic: (state: any, action: PayloadAction<any>) => {
      const payload = action.payload;
      state.profilePic = payload;
    },
    setsignedprofilepic: (state: any, action: PayloadAction<any>) => {
      const payload = action.payload;
      state.signedprofilepic = payload;
    },
    setis_FilePathset: (state: any, action: PayloadAction<any>) => {
      const payload = action.payload;

      state.is_FilePathset = payload;
    },
    resetUserProfilePic: (state: any) => {
      state.profilePic = "";
      state.signedprofilepic = "";
    },
  },
});

export const {
  setUserProfilePic,
  setis_FilePathset,
  setsignedprofilepic,
  resetUserProfilePic,
} = profilePicSlice.actions;

export default profilePicSlice.reducer;
